
import { Component, Vue } from 'vue-property-decorator'
//引入自定义卡片组件
import commdsClass from '@/views/goodsManage/commodity/subPage/commdsClass.vue'
import GoodsCategorySelect from '@/views/goodsManage/commodity/template/GoodsCategorySelect.vue'
import GoodsList from '@/views/goodsManage/commodity/template/GoodsList.vue'
import { Getter } from 'vuex-class'
import {
  GoodsListDto,
  getGoodsList,
  batchDisableGoods,
  batchUpGoods,
  batchDeleteGoods,
  batchDownGoods,
  deleteGoods,
  BatchRecommendGoods
} from '@/api/commodity'
import { downloadUrl } from '@/utils/util'
import { categoryDto } from '@/api/goods'
import { confirm } from '@/utils/decorator'
import { backToBefore } from '@/utils/h5ToApp'

@Component({
  name: 'Commodity',
  components: {commdsClass, GoodsCategorySelect, GoodsList}
})
export default class Commodity extends Vue {
  @Getter goodsId!: string
  @Getter companyId: string
  @Getter providerId!: string
  downloadUrl = downloadUrl
  show = false
  checkshow = false
  categoryName = '商品分类'

  //没有数据  目前所有的companyID、goodsId全部写死
  params = {
    goodsStatus: '1',
    pageIndex: 1,
    pageSize: 10,
    isPage: true,
    keyword: '',
    hierarchyId: ''
  }
  goodsList: GoodsListDto[] = []
  checkResult: { goodsId?: string }[] = []
  refreshing = false

  created () {
    this.getList()
  }

  activated () {
    // 解决keep-alive 返回页面时,页面还处于编辑状态的异常问题i
    this.show = false
    this.checkshow = false
    this.clearData()
    // 订单状态改变，刷新订单列表
    if (window.sessionStorage.getItem("isRefresh") === "1") {
      this.params.pageIndex = 1
      this.getList()
      window.sessionStorage.setItem("isRefresh", "0");
    }
  }

  mounted () {
    // 注册原生调用h5方法
    this.refreshPage()
  }

  //搜索
  toSearch () {
    this.$router.push({
      path: '/searchCommodity',
      query: {
        searchType: '3'
      }
    })
  }

  /**
   * h5返回原生上一级
   */
  handleBack () {
    // this.$goHomeBack()
    this.$router.back()
  }


  onLoad () {
    this.params.pageIndex = this.params.pageIndex + 1
    this.getList()
  }

  loading = false
  finished = false

  getList () {
    this.$nextTick(() => {
      (this.$refs.goodsList as GoodsList).getList(this.params)
    })
  }

  /**
   * 当点击底部导航，页面切换时，原生调用h5接口，重置管理按钮状态
   */
  refreshPage () {
    this.$bridge.registerHandler('refreshPage', (data: string, responseCallback) => {
      this.show = false
      this.checkshow = false
      responseCallback()
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  /**
   * @description: 管理事件
   * @param {*}
   * @return {*}
   */
  onManageTap () {
    if (this.show) {
      this.show = false
      this.checkshow = false
      this.clearData()
    } else {
      this.show = true
      this.checkshow = true
    }
  }

  //获取上架列表和数量
  getsjList () {
    this.params.goodsStatus = '1'
    this.params.pageIndex = 1
    this.getList()
  }

  //获取下架列表和数量
  getxjList () {
    this.params.goodsStatus = '2'
    this.params.pageIndex = 1
    this.getList()
  }

  //获取停用列表和数量
  gettyList () {
    this.params.goodsStatus = '3'
    this.params.pageIndex = 1
    this.getList()
  }

  activeState = 0

  // 上架
  showUp () {
    this.activeState = 0
    this.getsjList()
  }

  // 下架
  showDown () {
    this.activeState = 1
    this.getxjList()
  }

  // 停用
  showStop () {
    this.activeState = 2
    this.gettyList()
  }

  //商品分类
  showRules () {
    (this.$refs.goodsCategorySelect as GoodsCategorySelect).showModal()
  }

  /**
   * 商品分类回调
   */
  handleSelectCategory (data: categoryDto) {
    this.params.hierarchyId = data.categoryId === 'all' ? '' : data.categoryId
    this.categoryName = data.categoryId === 'all' ? '商品分类' : data.categoryName
    this.params.pageIndex = 1
    this.getList()
    this.clearData()
  }

  getGoodsIdListParam () {
    return this.checkResult.map(item => {
      return {
        goodsId: item
      }
    })
  }

  clearData () {
    this.checkResult = []
  }

  //...操作按钮
  delData (id: string) {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '确认删除吗?',
      onOk: () => {
        return this.delFunc(id)
      },
    })
  }

  delFunc (id: string) {
    const params = {
      companyId: this.companyId,
      goodsId: id
    }
    deleteGoods(params).then((res) => {
      this.$notify({
        type: 'success',
        message: '删除成功！',
      })
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    }).catch(() => {

    })
  }

  /**
   * 设为推荐商品
   */
  handleBatchRecommendGoods (ignoreDeleteTip = false) {
    // 删除按钮权限
    // if (!this.$action('recommend')) {
    //   return false
    // }
    if (!this.getGoodsIdListParam().length) {
      return this.$toast('请先选择需要设为推荐的商品')
    }
    this.handleBatchRecommendGoodsCb(ignoreDeleteTip)
  }

  @confirm('温馨提示', '确定设为推荐商品？')
  handleBatchRecommendGoodsCb (ignoreDeleteTip) {
    let params = {
      ignoreDeleteTip,
      goodsIdList: this.getGoodsIdListParam()
    }
    BatchRecommendGoods(params).then(res => {
      this.show = false
      this.checkshow = false
      if (res.data.isNeedConfirm) {
        this.batchRecommendGoodsConfirm()
      } else {
        this.$notify({
          type: 'success',
          message: '设置成功'
        })
        this.getList()
        this.clearData()
      }
    })
  }

  @confirm('温馨提示', '本次修改将删除推荐商品列表中的部分数据，是否确认修改？')
  batchRecommendGoodsConfirm () {
    this.handleBatchRecommendGoods(true)
  }

  /**
   * 批量上架
   */
  UpGoods () {
    // 删除按钮权限
    // if (!this.$action('UpGoods')) {
    //   return false
    // }
    if (!this.getGoodsIdListParam().length) {
      return this.$toast('请先选择需要上架的商品')
    }
    this.UpGoodsCb()
  }

  @confirm('温馨提示', '确定上架?')
  UpGoodsCb () {
    let params = {
      goodsIdList: this.getGoodsIdListParam()
    }
    batchUpGoods(params).then((res) => {
      this.$notify({
        type: 'success',
        message: '上架成功'
      })
      this.show = false
      this.checkshow = false
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    }).catch(() => {
    })
  }

  /**
   * 批量下架
   */
  DownGoods () {
    // 删除按钮权限
    // if (!this.$action('DownGoods')) {
    //   return false
    // }
    if (!this.getGoodsIdListParam().length) {
      return this.$toast('请先选择需要下架的商品')
    }
    this.DownGoodsCb()
  }

  @confirm('温馨提示', '确定下架?')
  DownGoodsCb () {
    let params = {
      goodsIdList: this.getGoodsIdListParam()
    }
    batchDownGoods(params).then((res) => {
      this.$notify({
        type: 'success',
        message: '下架成功'
      })
      this.show = false
      this.checkshow = false
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    }).catch(() => {
    })
  }

  /**
   * 批量停用
   */
  DisableGoods () {
    // 删除按钮权限
    // if (!this.$action('DisableGoods')) {
    //   return false
    // }
    if (this.checkResult.length <= 0) {
      return this.$toast('请先选择需要停用的商品')
    }
    this.DisableGoodsCb()
  }

  @confirm('温馨提示', '确认要停用吗?')
  DisableGoodsCb () {
    let params = {
      goodsIdList: this.getGoodsIdListParam()
    }
    batchDisableGoods(params).then(() => {
      this.$notify({
        type: 'success',
        message: '停用成功'
      })
      this.show = false
      this.checkshow = false
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    }).catch(() => {
    })
  }

  /**
   * 批量删除
   */
  DeleteGoods () {
    // 删除按钮权限
    // if (!this.$action('DeleteGoods')) {
    //   return false
    // }
    if (this.checkResult.length <= 0) {
      return this.$toast('请先选择需要删除的商品')
    }
    this.batchDeleteGoodsCb()
  }

  @confirm('温馨提示', '确认要删除吗?')
  batchDeleteGoodsCb () {
    let params = {
      'goodsIdList': this.getGoodsIdListParam()
    }
    batchDeleteGoods(params).then(() => {
      this.$notify({
        type: 'success',
        message: '删除成功'
      })
      this.show = false
      this.checkshow = false
      this.params.pageIndex = 1
      this.getList()
      this.clearData()
    }).catch(() => {
    })
  }

  /**
   * 进入详情页
   * @param e
   * @param id 关联id
   * @param goodsId 商品编号
   */
  toDetail (e: string, id: string, goodsId: string) {
    this.$router.replace({
      path: '/commodsDetail',
      query: {
        relationId: id,
        goodsId: goodsId
      }
    })
  }
}
